import { stickyHeader } from "./sticky-header";
import { stickyBackToTop, stickyLFDocNav } from "./scroll-links";
import { stickPageUtils } from "./page-utilities";

(function ($) {
  "use strict";

  $(document).ready(function () {
    scrollingInit();
  });
})(jQuery);

function scrollingInit() {
  var scroll, scroller;

  scroll =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    // IE Fallback, you can even fallback to onscroll
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };

  var forceScroller = false;
  var lastPosition = -1;
  var lastPageUtilsHeight = -1;
  var backToTopHeight = $("#back-to-top .back-to-top__button").outerHeight();
  var lastLongFromIndexHeight = -1;

  scroller = function () {
    var scrollValues = scrollVariables();

    if (
      lastPosition == scrollValues.scrollOffset &&
      lastPageUtilsHeight == scrollValues.pageUtilsHeight &&
      lastLongFromIndexHeight == scrollValues.longFormIndexHeight &&
      !forceScroller
    ) {
      scroll(scroller);
      return false;
    }

    var semiStaticScrollValues = semiStaticScrollVariables();

    stickyHeader(
      scrollValues.scrollOffset,
      semiStaticScrollValues.pageHeadHeight
    );
    stickPageUtils(
      scrollValues.scrollOffset,
      semiStaticScrollValues.mainContentOffset,
      semiStaticScrollValues.pageHeadHeight,
      semiStaticScrollValues.footerOffset,
      backToTopHeight,
      scrollValues.pageUtilsHeight,
      scrollValues.pageUtilsOffset
    );
    stickyBackToTop(
      scrollValues.scrollOffset,
      semiStaticScrollValues.screenHeight,
      semiStaticScrollValues.footerOffset
    );
    stickyLFDocNav(
      scrollValues.scrollOffset,
      semiStaticScrollValues.screenHeight,
      semiStaticScrollValues.longFormDocContentOffset,
      semiStaticScrollValues.pageHeadHeight,
      semiStaticScrollValues.footerOffset,
      scrollValues.longFormIndexHeight,
      semiStaticScrollValues.longFormDocHeaderHeight
    );

    lastPosition = scrollValues.scrollOffset;
    lastPageUtilsHeight = scrollValues.pageUtilsHeight;
    lastLongFromIndexHeight = scrollValues.longFormIndexHeight;
    forceScroller = false;
    scroll(scroller);
  };

  scroller();

  setTimeout(function () {
    var scrollValues = scrollVariables();
    var semiStaticScrollValues = semiStaticScrollVariables();

    stickPageUtils(
      scrollValues.scrollOffset,
      semiStaticScrollValues.mainContentOffset,
      semiStaticScrollValues.pageHeadHeight,
      semiStaticScrollValues.footerOffset,
      backToTopHeight,
      scrollValues.pageUtilsHeight
    );
    stickyBackToTop(
      scrollValues.scrollOffset,
      semiStaticScrollValues.screenHeight,
      semiStaticScrollValues.footerOffset
    );
    stickyLFDocNav(
      scrollValues.scrollOffset,
      semiStaticScrollValues.screenHeight,
      semiStaticScrollValues.longFormDocContentOffset,
      semiStaticScrollValues.pageHeadHeight,
      semiStaticScrollValues.footerOffset,
      scrollValues.longFormIndexHeight,
      semiStaticScrollValues.longFormDocHeaderHeight
    );
  }, 210);

  $(window).on("resize.scroller", function () {
    forceScroller = true;
  });
}


function scrollVariables() {
  const scrollTop = window.scrollY || window.pageYOffset;
  const utils = document.querySelector("#page-utilities");

  return {
    scrollOffset: scrollTop,
    pageUtilsHeight:
      $("#page-utilities > .outer > .inner").length > 0
        ? $("#page-utilities > .outer > .inner").outerHeight()
        : -1,
    pageUtilsOffset: utils ? utils.offsetTop : -1, // Simplified to just use offsetTop
    longFormIndexHeight:
      $("#lf-doc-nav").length > 0 ? $("#lf-doc-nav").outerHeight() : -1,
  };
}

function semiStaticScrollVariables() {
  return {
    screenHeight: window.innerHeight,
    mainContentOffset: $("#main-page-content").length
      ? $("#main-page-content").position().top
      : 0,
    footerOffset: $("#page-foot").length ? $("#page-foot").position().top : 0,
    pageHeadHeight: $("#page-head").length ? $("#page-head").outerHeight() : 0,
    longFormDocContentOffset:
      $(".lf-nav-wrapper").length > 0 ? $(".lf-doc-lower").position().top : -1,
    longFormDocHeaderHeight:
      $("#lf-doc-nav").length > 0 ? $("#lf-doc-nav > h2").outerHeight() : -1,
  };
}
